module.exports = __webpack_public_path__ + "static/media/process.ed133143.svg";